import "./App.css";
import AppRouter from "./appRouter";
import { Provider } from "react-redux";
import store from "./Redux/store";
// import useScanDetection from 'use-scan-detection';
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Base_Uri } from "./Constant/BaseUri";

function App() {
  const [barcode, setBarcode] = useState("");
  const [allowedCountries, setAllowedCountries] = useState([]);

  // const fetchCountries = () => {
  //   axios.get(`${Base_Uri}countries`)
  //     .then(res => setAllowedCountries(res.data))
  //     .catch(err => console.error("Error fetching countries:", err));
  // };
  const [isAllowed, setIsAllowed] = useState(false);
  // useEffect(() => {
  //   window.electronAPI.focusWindow?.();
  // }, []);
  // useScanDetection({
  //   onComplete: (code) => {

  //     setBarcode(code)

  // useEffect(()=>{
  //   fetchCountries()
  // },[])

  const [userData, setUserData] = useState([]);

  // useEffect(() => {
  //   fetch("https://api64.ipify.org?format=json")
  //     .then((res) => res.json())
  //     .then((data) => {setIp(data.ip)
  //       console.log(data.ip)
  //     })
  //     .catch((err) => console.error(err));
  // }, []);

  // useEffect(() => {
  //   fetch("http://ip-api.com/json/")
  //     .then((res) => res.json())
  //     .then((data) => setUserData(data)); // Full country name (e.g., "United States")
  // }, []);

  // useEffect(()=>{
  //     let checkAccess = allowedCountries.filter(e=>e.code==userData.countryCode)
  //     setIsAllowed(checkAccess.length!=0)
  // },[allowedCountries,userData])

  return (
    <Provider store={store}>
      {
        <div className="App">
          <AppRouter />
        </div>
      }
      
      {/* { <div className="restricted-container">
      <div className="warning-icon">⚠️</div>
      <h1>Access Denied</h1>
      <p>Sorry, your country is restricted from accessing this content.</p>
      
    </div>} */}
      <div
        style={{
          fontFamily: "Poppins",
          fontSize: 12,
          color: "#6e6e6e",
          fontWeight: "600",
          position: "fixed",
          bottom: 5,
          right: 5,
        }}
      >
        V1.1 (PORD)
      </div>
    </Provider>
  );
}

export default App;
